// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	CancelButton: 'cancel-button',
	SaveButton: 'save-button',
	HstCheckbox: 'hst-checkbox',
	IncludeDetailsCheckbox: 'include-details-checkbox',
	SumInput: 'sum-input',
	VendorCredit: 'vendor-credit',
	PurchaserCredit: 'purchaser-credit',
	CreditType: 'credit-type',
	EnrolmentDateSelect: 'enrolment-date-select',
	FeeRatesSelect: 'fee-rates-select',
	EnrolmentDateOption: 'enrolment-date-option',
	AgreedPriceOption: 'agreed-price-option',
	NetPriceOption: 'net-price-option',
	NetPriceRebateOption: 'net-price-rebate-option',
	SumOption: 'sum-option',
	HstAmount: 'hst-amount',
} as const;
